import { createRootRoute, createRoute, Outlet } from '@tanstack/react-router';
import { z } from 'zod';

import { FeedPage } from './routes/feed';
import { HomePage } from './routes/home';
import { LegacyDetailPage } from './routes/legacy-detail';
import { LegacyEditPage } from './routes/legacy-edit';
import { ProfilePage } from './routes/profile';
import { RandomPage } from './routes/random';
import { SignInPage } from './routes/sign-in';
import { SignUpPage } from './routes/sign-up';

const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
});

const signInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sign-in',
  validateSearch: z.object({ redirect: z.string().optional() }),
  component: SignInPage,
});

const signUpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sign-up',
  component: SignUpPage,
});

const profileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/profile',
  component: ProfilePage,
});

const feedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/feed',
  component: FeedPage,
});

const randomRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/random',
  component: RandomPage,
});

const legacyNewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/legacies/new',
  component: () => <LegacyEditPage mode="create" />,
});

const legacyEditRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/legacies/$id/edit',
  component: () => <LegacyEditPage mode="edit" />,
});

const legacyDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/legacies/$id',
  component: LegacyDetailPage,
});

export const routeTree = rootRoute.addChildren([
  indexRoute,
  signInRoute,
  signUpRoute,
  profileRoute,
  feedRoute,
  randomRoute,
  legacyNewRoute,
  legacyEditRoute,
  legacyDetailRoute,
]);